import { Component, OnInit, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ProjectsService } from '../../../services/projects.service';
import { ReportService } from '../../../services/report.service';

@Component({
  selector: 'app-generate-user-list',
  templateUrl: './generate-list.component.html',
  styleUrl: './generate-list.component.scss'
})
export class GenerateListComponent implements OnInit {  
  projects: Array<{id: string, name: string}> = [];
  roles: string[] = [];
  emails: any;
  running: boolean = false;
  
  constructor(
    @Optional() private readonly dialogRef: MatDialogRef<GenerateListComponent>,
    private readonly projectService: ProjectsService,
    private readonly reportsService: ReportService
  ){}
  
  ngOnInit() {
    this.projectService.getProjectRoles().subscribe((_: any) => {
      _.forEach((project: any) => {
        this.projects.push({id: project.projectId, name: project.projectName});
        project.roles.forEach((role:string) =>{
          if(!this.roles.includes(role)) {
            this.roles.push(role);
          }
        });
      });
    });
  }

  close() {
    this.dialogRef.close();
  }
  addTo(destination: string) {
    this.running = true;
    this.run().then(_ => {
      this.running = false;
      this.dialogRef.close({ type: destination, emails: _ });
    });
  }

  private run(): Promise<string> {
    return new Promise((resolve, reject) => {
      var projects: string[] = [];
      var projectCheckboxes = document.querySelectorAll("input.project-checkbox:checked");
      projectCheckboxes.forEach((checkbox: any) => {
        projects.push(checkbox.value);
      });

      var roles: string[] = [];
      var roleCheckboxes = document.querySelectorAll("input.role-checkbox:checked");
      roleCheckboxes.forEach((checkbox: any) => {
        roles.push(checkbox.value);
      });

      this.reportsService.getEmailList(projects, roles)
      .subscribe((_: any) => {
        var emails: string[] = [];
        _.forEach((item: any) => {
          emails.push(item.name + " <" + item.email + ">");
        });
        resolve(emails.join(';'));
      });
    });
  }
}
